const React = require('react');

function PaypalDescriptionBullets() {
  function htmlLineItem(text) {
    return (
      <li dangerouslySetInnerHTML={{ __html: text }} ></li>
    );
  }

  function mutedCaretIcon() {
    return '<span class="fa fa-caret-right fa-li muted"></span>';
  }

  return (
    <ul className="fa-ul font-tiny normal">
      {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.paypalPaymentMethodsHtml', { icon: mutedCaretIcon() }))}
      {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.paypalFeesHtml', { icon: mutedCaretIcon() }))}
      {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.paypalPoliciesApplyHtml', { icon: mutedCaretIcon() }))}
    </ul>
  );
}

module.exports = PaypalDescriptionBullets;



// WEBPACK FOOTER //
// ./javascripts/components/shop/paypal_description_bullets.jsx